/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: H60AHBPq_6nd

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicCapTopSection.module.css"; // plasmic-import: H60AHBPq_6nd/css

createPlasmicElementProxy;

export type PlasmicCapTopSection__VariantMembers = {};
export type PlasmicCapTopSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicCapTopSection__VariantsArgs;
export const PlasmicCapTopSection__VariantProps = new Array<VariantPropType>();

export type PlasmicCapTopSection__ArgsType = {};
type ArgPropType = keyof PlasmicCapTopSection__ArgsType;
export const PlasmicCapTopSection__ArgProps = new Array<ArgPropType>();

export type PlasmicCapTopSection__OverridesType = {
  top?: Flex__<"section">;
  header?: Flex__<"div">;
  sectionHeader?: Flex__<"div">;
  top2?: Flex__<"div">;
  subtitle?: Flex__<"div">;
  title?: Flex__<"div">;
  body?: Flex__<"div">;
  banner?: Flex__<"div">;
  sectionHeader2?: Flex__<"div">;
  top3?: Flex__<"div">;
  subtitle2?: Flex__<"div">;
  title2?: Flex__<"div">;
  body2?: Flex__<"div">;
};

export interface DefaultCapTopSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicCapTopSection__RenderFunc(props: {
  variants: PlasmicCapTopSection__VariantsArgs;
  args: PlasmicCapTopSection__ArgsType;
  overrides: PlasmicCapTopSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"top"}
      data-plasmic-override={overrides.top}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.top
      )}
    >
      <div
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames("all", sty.header)}
      >
        <div
          data-plasmic-name={"sectionHeader"}
          data-plasmic-override={overrides.sectionHeader}
          className={classNames("all", sty.sectionHeader)}
        >
          <div
            data-plasmic-name={"top2"}
            data-plasmic-override={overrides.top2}
            className={classNames("all", sty.top2)}
          >
            <div
              data-plasmic-name={"subtitle"}
              data-plasmic-override={overrides.subtitle}
              className={classNames("all", "__wab_text", sty.subtitle)}
            >
              {hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? "                    Platform Capabilities"
                : "Platform Capabilities"}
            </div>
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames("all", "__wab_text", sty.title)}
            >
              {hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? "       Supporting Every Aspect\n       of Medical Education"
                : "Supporting Every Aspect \nof Medical Education"}
            </div>
          </div>
          <div
            data-plasmic-name={"body"}
            data-plasmic-override={overrides.body}
            className={classNames("all", "__wab_text", sty.body)}
          >
            {hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? "                 MyEvaluations provides a comprehensive platform that supports \n                 the entire educational journey\u2014from learner assessments and \n                 competency management to institutional leadership, educational \n                 operations, and enterprise integrations. Every capability is designed \n                 to strengthen educational conversations and support Continuous \n                 Educational Improvement."
              : "MyEvaluations provides a comprehensive platform that supports \nthe entire educational journey\u2014from learner assessments and \ncompetency management to institutional leadership, educational \noperations, and enterprise integrations. Every capability is designed \nto strengthen educational conversations and support Continuous \nEducational Improvement."}
          </div>
        </div>
      </div>
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"banner"}
          data-plasmic-override={overrides.banner}
          className={classNames("all", sty.banner)}
        >
          <div
            data-plasmic-name={"sectionHeader2"}
            data-plasmic-override={overrides.sectionHeader2}
            className={classNames("all", sty.sectionHeader2)}
          >
            <div
              data-plasmic-name={"top3"}
              data-plasmic-override={overrides.top3}
              className={classNames("all", sty.top3)}
            >
              <div
                data-plasmic-name={"subtitle2"}
                data-plasmic-override={overrides.subtitle2}
                className={classNames("all", "__wab_text", sty.subtitle2)}
              >
                {"Platform Capabilities"}
              </div>
              <div
                data-plasmic-name={"title2"}
                data-plasmic-override={overrides.title2}
                className={classNames("all", "__wab_text", sty.title2)}
              >
                {"Supporting \nEvery Aspect \nof Medical Education"}
              </div>
            </div>
            <div
              data-plasmic-name={"body2"}
              data-plasmic-override={overrides.body2}
              className={classNames("all", "__wab_text", sty.body2)}
            >
              {
                "MyEvaluations provides a comprehensive platform that supports the entire educational journey\u2014from learner assessments and competency management to institutional leadership, educational operations, and enterprise integrations. Every capability is designed to strengthen educational conversations and support Continuous Educational Improvement."
              }
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  top: [
    "top",
    "header",
    "sectionHeader",
    "top2",
    "subtitle",
    "title",
    "body",
    "banner",
    "sectionHeader2",
    "top3",
    "subtitle2",
    "title2",
    "body2"
  ],
  header: ["header", "sectionHeader", "top2", "subtitle", "title", "body"],
  sectionHeader: ["sectionHeader", "top2", "subtitle", "title", "body"],
  top2: ["top2", "subtitle", "title"],
  subtitle: ["subtitle"],
  title: ["title"],
  body: ["body"],
  banner: ["banner", "sectionHeader2", "top3", "subtitle2", "title2", "body2"],
  sectionHeader2: ["sectionHeader2", "top3", "subtitle2", "title2", "body2"],
  top3: ["top3", "subtitle2", "title2"],
  subtitle2: ["subtitle2"],
  title2: ["title2"],
  body2: ["body2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  top: "section";
  header: "div";
  sectionHeader: "div";
  top2: "div";
  subtitle: "div";
  title: "div";
  body: "div";
  banner: "div";
  sectionHeader2: "div";
  top3: "div";
  subtitle2: "div";
  title2: "div";
  body2: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCapTopSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCapTopSection__VariantsArgs;
    args?: PlasmicCapTopSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCapTopSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCapTopSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCapTopSection__ArgProps,
          internalVariantPropNames: PlasmicCapTopSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCapTopSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "top") {
    func.displayName = "PlasmicCapTopSection";
  } else {
    func.displayName = `PlasmicCapTopSection.${nodeName}`;
  }
  return func;
}

export const PlasmicCapTopSection = Object.assign(
  // Top-level PlasmicCapTopSection renders the root element
  makeNodeComponent("top"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    top2: makeNodeComponent("top2"),
    subtitle: makeNodeComponent("subtitle"),
    title: makeNodeComponent("title"),
    body: makeNodeComponent("body"),
    banner: makeNodeComponent("banner"),
    sectionHeader2: makeNodeComponent("sectionHeader2"),
    top3: makeNodeComponent("top3"),
    subtitle2: makeNodeComponent("subtitle2"),
    title2: makeNodeComponent("title2"),
    body2: makeNodeComponent("body2"),

    // Metadata about props expected for PlasmicCapTopSection
    internalVariantProps: PlasmicCapTopSection__VariantProps,
    internalArgProps: PlasmicCapTopSection__ArgProps
  }
);

export default PlasmicCapTopSection;
/* prettier-ignore-end */
